<template>
  <div class="case-detail">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="成功详情"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!--成功案例列表-->
    <template v-if="detail">
    <div>
      <van-panel :title="detail.title" :desc="detail.province+detail.city+detail.district+detail.address" style="font-size: 12px;" />
      <div style="margin-top: 20px; text-align: center;">
        <img :src="uploadsUrl+detail.picture">
      </div>
      <van-panel :title="detail.content" style="font-size: 12px;" />
      <van-panel title="" :desc="'日期：'+detail.created_at" style="font-size: 12px;" />
    </div>
    </template>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'caseDetail',
    data() {
        return {

        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            detail: state => state.cases.cases_detail.data
        })
    },
    methods: {
      ...mapActions(['requestCasesDetail']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/case/list'});
        },
        filterBy(list,value){
            return list.filter(function(lists){
                return lists.city.match(value);
            })
        }
    },
    components: {

    },
    mounted() {
      this.requestCasesDetail({"thit":this,"id":this.$route.params.id});
    },
    beforeCreate() {
        this.uploadsUrl = 'https://a.chengdai.cn/uploads/'
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.case-detail >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.case-detail >>> .van-nav-bar__text {
  color: #fff;
}
.case-detail >>> .van-nav-bar__title {
  color: #fff;
}
.case-detail >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.case-detail >>> .van-nav-bar .van-icon {
  color: #fff;
}
</style>
